module.exports = __webpack_public_path__ + "img/9788960175600.f7d07cbe.jpg";